import { h, Fragment } from 'preact'
import Post from './Post';
import USPRow from './USPRow';
import Loader from './Loader';
import OrderBy from './Orderby';
import SearchFilter from '../components/SearchFilter';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Posts = props => {
  let { posts } = props;
  const offset = props.offset;
  const activeClass = props.showAll ? 'active' : '';
  const addLabel = props.addLabel ? props.addLabel : 'Add';
  const readMoreLabel = props.readMoreLabel ? props.readMoreLabel : 'Read more';
  const suggestedLabel = props.suggestedLabel ? props.suggestedLabel : 'Suggested filters:';
  const uspOne = props.uspOne ? props.uspOne : '';
  const uspTwo = props.uspTwo ? props.uspTwo : '';
  const uspThree = props.uspThree ? props.uspThree : '';
  const suggestedAnimal = props.suggestedAnimal ? props.suggestedAnimal : false;
  const suggestedBrand = props.suggestedBrand ? props.suggestedBrand : false;
  const suggestedCategory = props.suggestedCategory ? props.suggestedCategory : false;
  const language = (props.currentLanguage !== '') ? props.currentLanguage : 'en';
  const searchPlaceholder = props.searchText ? props.searchText : '';
  const loggedIn = props.loggedIn ? props.loggedIn : '';

  const shownArray = [
    { id: '', title: 'shown' },
    { id: 'en', title: 'shown' },
    { id: 'be', title: 'getoond' },
    { id: 'da', title: 'vist' },
    { id: 'fi', title: 'näytetty' },
    { id: 'fr', title: 'montré' },
    { id: 'fr-be', title: 'montré' },
    { id: 'de', title: 'gezeigt' },
    { id: 'it', title: 'mostrato' },
    { id: 'nl', title: 'getoond' },
    { id: 'no', title: 'vist' },
    { id: 'es', title: 'mostrado' },
    { id: 'sv', title: 'visad' },
    { id: 'uk', title: 'shown' },
    { id: 'gb', title: 'shown' },
    { id: 'us', title: 'shown' }
  ]
  let shownLabel = (language) ? shownArray.find(
    ({ id }) => id === language
  ) : 'shown';
  shownLabel = shownLabel.title ? shownLabel.title : 'Shown';

  const loadArray = [
    { id: '', title: 'Load more' },
    { id: 'en', title: 'Load more' },
    { id: 'be', title: 'Laad meer' },
    { id: 'da', title: 'Indlæs mere' },
    { id: 'fi', title: 'Lataa lisää' },
    { id: 'fr', title: 'Charger plus' },
    { id: 'fr-be', title: 'Charger plus' },
    { id: 'de', title: 'Mehr laden' },
    { id: 'it', title: 'Carica altro' },
    { id: 'nl', title: 'Laad meer' },
    { id: 'no', title: 'Last mer' },
    { id: 'es', title: 'Cargar más' },
    { id: 'sv', title: 'Ladda mer' },
    { id: 'uk', title: 'Load more' },
    { id: 'gb', title: 'Load more' },
    { id: 'us', title: 'Load more' }
  ]
  let loadLabel = (language) ? loadArray.find(
    ({ id }) => id === language
  ) : 'Load more';
  loadLabel = loadLabel.title ? loadLabel.title : 'Load more';

  const loadedArray = [
    { id: '', title: 'All loaded' },
    { id: 'en', title: 'All loaded' },
    { id: 'be', title: 'Alles geladen' },
    { id: 'da', title: 'Alt indlæst' },
    { id: 'fi', title: 'Kaikki ladattu' },
    { id: 'fr', title: 'Tout chargé' },
    { id: 'fr-be', title: 'Tout chargé' },
    { id: 'de', title: 'Alles geladen' },
    { id: 'it', title: 'Tutto caricato' },
    { id: 'nl', title: 'Alles geladen' },
    { id: 'no', title: 'Alt lastet' },
    { id: 'es', title: 'Todo cargado' },
    { id: 'sv', title: 'Allt laddat' },
    { id: 'uk', title: 'All loaded' },
    { id: 'gb', title: 'All loaded' },
    { id: 'us', title: 'All loaded' }
  ]
  let loadedLabel = (language) ? loadedArray.find(
    ({ id }) => id === language
  ) : 'All loaded';
  loadedLabel = loadedLabel.title ? loadedLabel.title : 'All loaded';

  return (
    <div className="c-shop-overview__posts u-flex" data-lang={`${language}`}>
      <div className="c-shop-overview__posts-top-bar u-flex u-flex-sb">
        <div className="c-shop-overview__posts-top-content u-flex u-flex-v-center">
          {suggestedAnimal.length || suggestedBrand.length || suggestedCategory.length ? (
            <Fragment>
              {suggestedLabel}

              <div className="c-shop-overview__suggested-filters u-flex">
                {suggestedAnimal.length ? (
                  suggestedAnimal.map(item => {
                    const currentCategory = props.animals.filter(category => category.id == item);
                    const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
                    const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
                    if (!currentCategoryName.length) return;
                    return <Item handleSuggested={props.handleSuggested} id={currentCategoryID} target="currentAnimals" item={currentCategoryName} />;
                  })
                ) : null }
                
                {suggestedBrand.length ? (
                  suggestedBrand.map(item => {
                    const currentCategory = props.brands.filter(category => category.id == item);
                    const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
                    const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
                    if (!currentCategoryName.length) return;
                    return <Item handleSuggested={props.handleSuggested} id={currentCategoryID} target="currentBrands" item={currentCategoryName} />;
                  })
                ) : null }

                {suggestedCategory.length ? (
                  suggestedCategory.map(item => {
                    const currentCategory = props.categories.filter(category => category.id == item);
                    const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
                    const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
                    if (!currentCategoryName.length) return;
                    return <Item handleSuggested={props.handleSuggested} id={currentCategoryID} target="currentCategories" item={currentCategoryName} />;
                  })
                ) : null }
              </div>
            </Fragment>
          ) : null}
        </div>

        <SearchFilter 
          searchText=''
          onSearch={props.onSearch}
          onSubmit={props.onSubmit}
          placeholder={searchPlaceholder}
          searchActive={props.searchActive}
          isLoading={props.isLoading}
        />
      </div>

      <div class="c-shop-overview__count u-flex u-flex-sb">
        ({props.nrAll}) {props.itemsLabel}

        <div class="u-hide-on-small">
          <OrderBy
            order={props.order}
            onSelectOrder={props.handleOrderChoice}
            postsLoading={props.loading}
            language={language}
          />
        </div>
      </div>

      {posts.map((post, index) => {
        if (index == 6 && uspOne ) {
          return (
            <USPRow
              uspOne={uspOne}
              uspTwo={uspTwo}
              uspThree={uspThree}
            />
          )
        } else {
          if (offset == 0) {
            if (index < 15) {
              return <Post key={post.id} post={post} add={addLabel} readMore={readMoreLabel} language={language} loggedIn={loggedIn} />;
            }
          } else {
            return <Post key={post.id} post={post} add={addLabel} readMore={readMoreLabel} language={language} loggedIn={loggedIn} />;
          }
        }
      })}

      {props.loading ? <Loader /> : null}

      {props.nrAll > props.count && !props.loading ? (
        <div className="c-shop-overview__toggle-button-container">
          <div className="c-shop-overview__posts-count">
            {posts.length} of {props.nrAll} {shownLabel}
          </div>

          {!(props.nrAll == posts.length) ? (
            <div className={`c-shop-overview__toggle-button u-flex ${activeClass}`} onClick={props.handleShowMore}>
              <div className="c-shop-overview__show-more">{loadLabel}</div>
              <div className="c-shop-overview__show-less">{loadedLabel}</div>
            </div>
          ) : null }
        </div>
      ) : null }
    </div>
  );
};

const Item = props => {
  return (
    <div className="c-shop-filters__item c-shop-filters__suggested-item" onClick={props.handleSuggested} data-id={props.id} data-target={props.target} data-name={props.item}>
      {props.label ? props.label : props.item}
    </div>
  );
};

export default Posts;


// WEBPACK FOOTER //
// ./src/js/shop/components/Posts.js